import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { ru } from './locales/ru';
export var ELanguage;
(function (ELanguage) {
    ELanguage["Ru"] = "ru";
})(ELanguage || (ELanguage = {}));
export const defaultLanguage = ELanguage.Ru;
const translations = {
    [ELanguage.Ru]: { translation: ru }
};
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    debug: false,
    returnNull: false,
    fallbackLng: defaultLanguage,
    interpolation: {
        escapeValue: false
    },
    resources: translations,
    detection: {
        order: ['navigator'],
        caches: []
    }
});
export { i18n };
export const getCurrentLang = () => i18n.t('locale');
//# sourceMappingURL=i18n.js.map